import type { TFunction } from "i18next";
import { u3125FormatCurrency } from "../../../../../u3125Facture/U3125";
import { NS } from "../../../../U3121";
import type { U3121BillingSubProjectAggregate } from "../../../../U3121Service";

interface U3121BillingSummarySubProjectBreakdownProps {
  bySubProject: U3121BillingSubProjectAggregate[];
  t: TFunction;
}

function U3121BillingSummarySubProjectBreakdown({ bySubProject, t }: U3121BillingSummarySubProjectBreakdownProps) {
  if (!bySubProject.length) return null;

  return (
    <div className="mt-3">
      <p className="mb-1 text-xs font-medium text-muted-foreground">{t("lblBillingSummaryBySubProject", { ns: NS })}</p>
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-muted-foreground">
            <th className="pb-1 font-medium">{t("lblSubProject", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblLineCount", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblTotalAmount", { ns: NS })}</th>
            <th className="pb-1 text-right font-medium">{t("lblTotalCostAmount", { ns: NS })}</th>
          </tr>
        </thead>
        <tbody>
          {bySubProject.map((row) => {
            const label = [row.subProjetNumber, row.subProjetName].filter(Boolean).join(" — ") || row.subProjectId || "—";
            return (
              <tr key={row.subProjectId ?? label} className="border-t border-gray-100">
                <td className="py-1">{label}</td>
                <td className="py-1 text-right tabular-nums">{row.lineCount ?? 0}</td>
                <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalAmount)}</td>
                <td className="py-1 text-right tabular-nums">{u3125FormatCurrency(row.totalCostAmount)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default U3121BillingSummarySubProjectBreakdown;
